import { i18n } from '@/locales';
// 락타임
// https://www.notion.so/barogohq/b8632665b3874edd8725b90ba7132028?p=deb1bad564bb46eeb1494cecf132eefa&pm=s
// 종류 ex)사용안함, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 5분, 10분
// 화면 표시 단위 초/분으로 나뉨
// 초 단위: 1 - 100
// 분 단위: 5분, 10분
const assignedWorkerLockTimeOptionList = [];
const TEN_SECOND = 10;
const ONE_HUNDRED_SECOND = 100;
const FIVE_MINUTE = 5 * 60;
const TEN_MINUTE = 10 * 60;
for (let i = 0; i <= TEN_MINUTE; i += 1) {
    if (i < TEN_SECOND
        || (i <= ONE_HUNDRED_SECOND && i % TEN_SECOND === 0)
        || (i === FIVE_MINUTE)
        || (i === TEN_MINUTE)) {
        assignedWorkerLockTimeOptionList.push(i);
    }
}
export default assignedWorkerLockTimeOptionList.map((time) => {
    let text = i18n.t('common.not_use');
    if (time > 0) {
        text = time >= FIVE_MINUTE
            ? i18n.t('common.minutes_suffix', {
                minutes: time / 60,
            })
            : i18n.t('common.second_suffix', {
                second: time,
            });
    }
    return ({
        text,
        value: time,
    });
});
